import React, { useState } from "react";
import { saveB2BClient, deleteB2BClient } from "../../data/b2bClients";

export default function B2BClientsTab({ clients, setClients }) {
  const emptyForm = { id: null, companyName: "", contactName: "", siret: "", tva: "", address: "", deliveryAddress: "", deliveryAddresses: [], phone: "", email: "" };
  const [formData, setFormData] = useState(emptyForm);
  const [isEditing, setIsEditing] = useState(false);
  const [editingAddrIdx, setEditingAddrIdx] = useState(null);
  const [addrDraft, setAddrDraft] = useState({ label: "", address: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.companyName) return;
    const saved = await saveB2BClient(formData);
    
    // Update local state
    if (isEditing) {
      setClients(clients.map(c => c.id === saved.id ? saved : c));
    } else {
      setClients([...clients, saved]);
    }

    setFormData(emptyForm);
    setIsEditing(false);
    setEditingAddrIdx(null);
  };

  const handleEdit = (client) => {
    setFormData({ ...client, deliveryAddresses: (client.deliveryAddresses || []).map(a => ({ ...a })) });
    setIsEditing(true);
    setEditingAddrIdx(null);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ce client ?")) return;
    await deleteB2BClient(id);
    setClients(clients.filter(c => c.id !== id));
  };

  const startAddAddress = () => {
    setAddrDraft({ label: "", address: "" });
    setEditingAddrIdx("new");
  };

  const startEditAddress = (idx) => {
    const addr = formData.deliveryAddresses[idx];
    setAddrDraft({ label: addr.label, address: addr.address });
    setEditingAddrIdx(idx);
  };

  const confirmAddress = () => {
    const label = addrDraft.label.trim();
    const address = addrDraft.address.trim();
    if (!label && !address) {
      setEditingAddrIdx(null);
      return;
    }
    const addresses = formData.deliveryAddresses || [];
    if (editingAddrIdx === "new") {
      setFormData({ ...formData, deliveryAddresses: [...addresses, { id: "d" + Date.now() + "-" + Math.random().toString(36).slice(2, 6), label, address }] });
    } else if (editingAddrIdx !== null) {
      setFormData({ ...formData, deliveryAddresses: addresses.map((a, i) => i === editingAddrIdx ? { ...a, label, address } : a) });
    }
    setEditingAddrIdx(null);
  };

  const cancelAddress = () => setEditingAddrIdx(null);

  const deleteAddress = (idx) => {
    setEditingAddrIdx(null);
    setFormData({ ...formData, deliveryAddresses: formData.deliveryAddresses.filter((a, i) => i !== idx) });
  };

  return (
    <div className="mt-4">
      <div className="card shadow-sm mb-4">
        <div className="card-header bg-white">
          <h5 className="mb-0">{isEditing ? "Modifier Client Pro" : "Nouveau Client Pro"}</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Nom de l'établissement *</label>
                <input type="text" className="form-control" value={formData.companyName} onChange={e => setFormData({...formData, companyName: e.target.value})} required />
              </div>
              <div className="col-md-6">
                <label className="form-label">Contact (Nom, Prénom)</label>
                <input type="text" className="form-control" value={formData.contactName} onChange={e => setFormData({...formData, contactName: e.target.value})} />
              </div>
              <div className="col-md-6">
                <label className="form-label">SIRET</label>
                <input type="text" className="form-control" value={formData.siret} onChange={e => setFormData({...formData, siret: e.target.value})} />
              </div>
              <div className="col-md-6">
                <label className="form-label">N° TVA</label>
                <input type="text" className="form-control" value={formData.tva} onChange={e => setFormData({...formData, tva: e.target.value})} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Adresse de facturation</label>
                <input type="text" className="form-control" value={formData.address} onChange={e => setFormData({...formData, address: e.target.value})} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Adresse de livraison (si différente)</label>
                <input type="text" className="form-control" value={formData.deliveryAddress} onChange={e => setFormData({...formData, deliveryAddress: e.target.value})} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Téléphone</label>
                <input type="text" className="form-control" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Email</label>
                <input type="email" className="form-control" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} />
              </div>
              <div className="col-12">
                <div className="border rounded p-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="mb-0">Adresses de livraison</h6>
                    {editingAddrIdx === null && (
                      <button type="button" className="btn btn-sm btn-outline-primary" onClick={startAddAddress}>
                        <i className="fas fa-plus me-1"></i>Ajouter une adresse
                      </button>
                    )}
                  </div>
                  {(formData.deliveryAddresses || []).map((addr, idx) => (
                    <div key={addr.id} className="d-flex justify-content-between align-items-start border-top pt-2 mt-2">
                      {editingAddrIdx === idx ? (
                        <div className="w-100">
                          <div className="mb-2">
                            <input type="text" className="form-control form-control-sm" placeholder="Libellé (ex. Dépôt central)" value={addrDraft.label} onChange={e => setAddrDraft({...addrDraft, label: e.target.value})} />
                          </div>
                          <div className="mb-2">
                            <input type="text" className="form-control form-control-sm" placeholder="Adresse complète" value={addrDraft.address} onChange={e => setAddrDraft({...addrDraft, address: e.target.value})} />
                          </div>
                          <div className="text-end">
                            <button type="button" className="btn btn-sm btn-primary me-2" onClick={confirmAddress}>
                              <i className="fas fa-check me-1"></i>OK
                            </button>
                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={cancelAddress}>Annuler</button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="me-2">
                            <div className="fw-semibold">{addr.label || "Sans libellé"}</div>
                            <div className="text-muted small">{addr.address}</div>
                          </div>
                          <div className="text-nowrap">
                            <button type="button" className="btn btn-sm btn-outline-secondary me-2" onClick={() => startEditAddress(idx)} title="Modifier">
                              <i className="fas fa-edit"></i>
                            </button>
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => deleteAddress(idx)} title="Supprimer">
                              <i className="fas fa-trash"></i>
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                  {editingAddrIdx === "new" && (
                    <div className="border-top pt-2 mt-2">
                      <div className="mb-2">
                        <input type="text" className="form-control form-control-sm" placeholder="Libellé (ex. Dépôt central)" value={addrDraft.label} onChange={e => setAddrDraft({...addrDraft, label: e.target.value})} />
                      </div>
                      <div className="mb-2">
                        <input type="text" className="form-control form-control-sm" placeholder="Adresse complète" value={addrDraft.address} onChange={e => setAddrDraft({...addrDraft, address: e.target.value})} />
                      </div>
                      <div className="text-end">
                        <button type="button" className="btn btn-sm btn-primary me-2" onClick={confirmAddress}>
                          <i className="fas fa-check me-1"></i>OK
                        </button>
                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={cancelAddress}>Annuler</button>
                      </div>
                    </div>
                  )}
                  {(formData.deliveryAddresses || []).length === 0 && editingAddrIdx === null && (
                    <div className="text-muted small">Aucune adresse de livraison.</div>
                  )}
                </div>
              </div>
              <div className="col-12 text-end">
                {isEditing && (
                  <button type="button" className="btn btn-secondary me-2" onClick={() => {
                    setIsEditing(false);
                    setFormData(emptyForm);
                    setEditingAddrIdx(null);
                  }}>Annuler</button>
                )}
                <button type="submit" className="btn btn-primary">{isEditing ? "Enregistrer les modifications" : "Ajouter le client"}</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th>Établissement</th>
              <th>Contact</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>Ville / Adresse</th>
              <th className="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {(clients || []).map(client => (
              <tr key={client.id}>
                <td><strong>{client.companyName}</strong></td>
                <td>{client.contactName}</td>
                <td>{client.email}</td>
                <td>{client.phone}</td>
                <td>{client.address}</td>
                <td className="text-end">
                  <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => handleEdit(client)}>
                    <i className="fas fa-edit"></i>
                  </button>
                  <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(client.id)}>
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
            {(!clients || clients.length === 0) && (
              <tr>
                <td colSpan="6" className="text-center py-4 text-muted">Aucun client pro trouvé.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

